// extracted by mini-css-extract-plugin
export var footer = "page-layout-module--footer--88767";
export var main = "page-layout-module--main--62679";
export var menu = "page-layout-module--menu--53760";
export var page = "page-layout-module--page--21056";
export var section = "page-layout-module--section--d2622";
export var sectionPlain = "page-layout-module--sectionPlain--59211";